import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import H2Title from './public/h2Title'
import Ltyw from './home/ltyw'
import Hygk from './home/hygk'
import Hyjj from './home/hyjj'
import { getYwzxList } from '../api/api'

const Ywzx = () => {
  const [data, setData] = useState(0)

  useEffect(() => {
    getYwzxList().then(res => {
      console.log(res)
      setData(res?.data)
    })
  }, [])

  return (
    <Layout>
      <Subpages name="要闻资讯">
        <Ltyw imgNews={data?.imgNews} impNewsList={data.impNewsList} />
        <Hyjj meetNewsList={data?.meetNewsList} />
        <div className="mb-10 lg:mb-0" />
      </Subpages>
    </Layout>
  )
}

export default Ywzx
